import { API_URL } from '@hellodarwin/core/lib/api';
import axios from 'axios';

export interface OauthOptions {
  domain: string;
  client_id: string;
  audience: string;
  scope: string;
}

// fetchOauthOptions from the API
export const fetchOauthOptions = async (
  appName: string,
): Promise<OauthOptions> => {
  const response = await axios
    .create({ baseURL: API_URL })
    .get<OauthOptions>(`/oauth/${appName}`);

  return { ...response.data };
};

export const resendEmailVerification = async (
  accessToken: string,
): Promise<void> => {
  await axios
    .create({
      baseURL: `${API_URL}/client`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .post('/email-verification/resend');
};
